import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';

export const paymentOrdersMetadata = {
  displayName: msg({
    message: 'Payment orders',
    context: 'Activity data schema name for payment orders',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    is_aligned_to_standard_terms: {
      displayName: msg({
        message: 'Is aligned to standard terms',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message:
          "Whether or not the payment is aligned to the undertaking's standard terms.",
        context: 'Is aligned to standard terms',
      }),
    },
    payment_order_id: {
      displayName: msg({
        message: 'Payment order ID',
        context: 'Unique way to identify the payment order.',
      }),
      externalDescription: msg({
        message: 'Unique way to identify the payment order.',
        context: 'Payment order ID',
      }),
    },
    payment_term_end: {
      displayName: msg({
        message: 'Payment term end date',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message: 'The date the payment term ends.',
        context: 'Payment term end date',
      }),
    },
    payment_term_start: {
      displayName: msg({
        message: 'Payment term start date',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({
        message: 'The date the payment term starts.',
        context: 'Payment term start date',
      }),
    },
    vendor_category_type: {
      displayName: msg({
        message: 'Supplier category',
        context: 'The display name for a dimension',
      }),
      externalDescription: msg({ message: 'The category of supplier.' }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
